import {FLIGHT_STATUS} from "@app/enums";

export function stbPallSeat(reservation) {
  let avilistpas = 0;
  let segAct = reservation.segments.find(s => s.flightStatus == FLIGHT_STATUS.OPENCI_ST && s.segmentCode == reservation.flightSummary.segmentCode)
  if(segAct){
    if(reservation.flightSummary.legPercentage > 0) {
      if (segAct.cabinInfo.available > 0) {
        let pallSeat = Math.floor((reservation.flightSummary.legPercentage * segAct.cabinInfo.authorized) / 100);
        avilistpas = pallSeat - reservation.flightSummary.pallTotalListed;
      }
    }
  }
  return (avilistpas > 0);
}

export function isStbEmployee(reservation) {
  return (reservation.isEmployee === true && reservation.isStandBy === true);
}
